import React from 'react';
import './App.css'; // Assuming your CSS file
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom

const Service11 = () => {
    const navigate = useNavigate(); // Initialize navigate

    // Function to handle navigation
    const handleNavigate = () => {
        navigate('/galleries'); // Navigate to the gallery page
    };

    return (

    <div className="about-events-container">
                    {/* First table for images and content */}

                    <div className="about-events-images">
                                     <img src="/images/aw1.jpg"  />
                                     <img src="/images/aw2.jpg" />
                                     <img src="/images/aw3.jpg" />
                                     <img src="/images/aw4.jpg" />
                                   </div>

                        <div className="about-events-content">
                                                    <h2 className="about-header-service">Awrudu Celebration at Cocoloco</h2>
                                                    <p className="about-events-description">

                            <p>Celebrate the spirit of Sinhala and Tamil New Year (Awrudu) at Cocoloco Garden with your family, friends, and colleagues! Our lush garden setting provides the perfect location for enjoying traditional Awrudu festivities, where you can immerse yourself in the cultural charm and vibrant atmosphere of this special occasion.</p>

                                                <p>We offer a variety of exciting Awrudu games that are perfect for all ages. Bring out your competitive spirit and enjoy classic games.</p>



                                                <p>We also offer a variety of delicious Awrudu treats and food stations, where you can savor traditional sweets like <em>Kavum</em>, <em>Kokis</em>, and <em>Asmi</em> while enjoying the festivities.</p>

                                                <p>Whether it's a family gathering, a corporate event with your colleagues, or a day out with friends, Cocoloco Garden promises a day full of laughter, fun, and cherished memories. We’ve curated the perfect environment for everyone to enjoy the Awrudu games, bond with loved ones, and experience the rich cultural traditions of Sri Lanka.</p>



</p>
                            <button className="service-button" onClick={handleNavigate}>
                                Click Here For See More Gallery ..
                            </button>
                       </div>

                                                                               </div>
    );
};

export default Service11;
